<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('working-shifts')" :icon="'grid'" />
            </div>
            <div 
                class="col-sm-12 col-md-6 breadcrumb-side-button"
                v-if="this.$can('store_working-shifts')"
            >
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <working-shift-add-edit-modal v-if="isAddEditModalActive" v-model="isAddEditModalActive"
             :table-id="tableId" :selected-url="selectedUrl" @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="working-shift-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { status } from '../../../Mixins/FilterMixin';
import {formatDateToLocal} from "../../../../common/Helper/Support/DateTimeHelper";


export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppWorkingShifts",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'working-shifts-table',
            rowData: {},
            options: {
                name: 'AppWorkingShifts',
                url: actions.WORKING_SHIFT,
                showHeader: true,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('#'),
                        type: 'text',
                        key: 'id',
                    },
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',
                    },
                    {
                        title: this.$t('type'),
                        type: 'custom-html',
                        key: 'type',
                        isVisible: true,
                        modifier: type => type ? `<span class="badge badge-pill badge-${type === 'regular' ? 'primary' : 'success'}">${this.$t(type)}</span>` : '-'
                    },
                    {
                        title: this.$t('location'),
                        type: 'object',
                        key: 'location',
                        modifier: (location => location?.name)
                    },

                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'working-shift-add-edit-modal',
                        modalId: 'working-shift-add-edit-modal',
                        modifier: () => this.$can('update_working-shifts'),

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'user-delete',
                        modifier: () => this.$can('delete_working-shifts'),
                    }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            $("#working-shift-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.WORKING_SHIFT}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.WORKING_SHIFT}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#working-shift-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
